(function() {

	var scrollTo = '.js-scroll-to';
	var $scrollTo = $(scrollTo);

	var params = {
		classes: {
			accordion: 'js-accordion',
			accordionTrigger: 'js-accordion-trigger',
			accordionExtraTrigger: 'js-accordion-extra-trigger',
			accordionContent: 'js-accordion-content'
		},
		toggleSpeed: 'slow'
	};

	//	======================================================================  //
	//	Functions
	//	======================================================================  //

	/**
	 * @function `scrollToTarget`
	 *
	 * Scrolls through the page to the defined target.
	 *
	 * @param $link (node) - a jQuery object
	 *
	 * 1. If the link has the class `.js-accordion-extra-trigger`, the target
	 *    scroll position will be the one of the accordion parent.
	 * 2. Substract the height of the header.
	 * 3. If the link is related to an accordion and the content of this accordion
	 *    is not visible yet, show it.
	 */
	function scrollToTarget( $link ) {
		var offset = _$siteHeader.outerHeight();
		var trigger_value = $link.hasClass(params.classes.accordionExtraTrigger);
		var $target = trigger_value ?
			$($link.attr('href')).closest('.' + params.classes.accordion) :
			$($link.attr('href')); /* [1] */

		_$htmlBody.animate({ /* [2] */
			scrollTop: $target.offset().top - offset /* [2] */
		}, params.toggleSpeed);

		/* [3] */
		if( trigger_value &&
			!$target.find('.' + params.classes.accordionContent).is(':visible') ) {
			$target.find('.' + params.classes.accordionTrigger).trigger('click');
		}
	}

	// ======================================================================  //
	//  On click
	//  ======================================================================  //

	_$document.on('click', scrollTo, function(e) {
		e.preventDefault();
		scrollToTarget($(this));
	});

})();
